export default __webpack_public_path__ + "static/media/tick-inactive.18fedb99.svg";